import React from 'react';
import { Button } from 'components';
import './styles.less';

export function StepButtons({
  onNext = () => {},
  onBack = () => {},
  disableNext = false,
  hideNext = false,
  hideBack = false,
  loading = false,
  secondary = false,
}) {
  return (
    <div className="stepButtons">
      {!hideBack && (
        <Button
          className={secondary ? 'secondary' : 'primary'}
          onClick={onBack}>
          back
        </Button>
      )}
      {!hideNext && (
        <Button
          className={secondary ? 'secondary' : 'primary'}
          onClick={onNext}
          disabled={disableNext}
          loading={loading}
          style={{ cursor: disableNext ? 'not-allowed' : 'pointer', }}>
          next
        </Button>
      )}
    </div>
  );
}